import React from "react";
import Markdown from "~/components/Markdown";
import Collapsable from "~/components/Collapsable";
import { Badge, Card, Link, Table, Text } from "~/components-shared";
import { CollapsableTypeEnum, TopicFootprintActionEnum, TopicFootprintTypeEnum } from "~/types/enums";
import FootprintActions from "~/components/FootprintActions";
import { truncatedContent } from "~/lib/helpers";
import styled from "styled-components";
const Underline = styled.span`
  text-decoration: underline;
  font-weight: 600;
`;
const StyledTd = styled(Table.Td)`
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
`;
const TopicFootprintContentSalesforce = _ref => {
  let {
    footprint,
    hideDetails = false,
    hideMessage = false
  } = _ref;
  const {
    actions,
    type,
    data
  } = footprint;
  if ([TopicFootprintTypeEnum.ACCOUNT].includes(type)) {
    const {
      accountUrl,
      accountName,
      accountDescription,
      accountIndustry,
      accountEmployees,
      userOwnedByName,
      userOwnedByUrl,
      accountCurrency,
      accountAnnualRevenue,
      customFields
    } = data;
    const currency = accountCurrency || "$";
    return /*#__PURE__*/React.createElement(React.Fragment, null, !hideDetails && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      display: "block",
      color: "textSecondary",
      weight: "semiBold"
    }, /*#__PURE__*/React.createElement(FootprintActions, {
      actions: actions
    }), " a Salesforce", " ", /*#__PURE__*/React.createElement(Link, {
      href: accountUrl,
      underline: true
    }, "account"), " ", userOwnedByName && /*#__PURE__*/React.createElement(Text, null, "owned by", " ", /*#__PURE__*/React.createElement(Link, {
      href: userOwnedByUrl,
      underline: true
    }, userOwnedByName), " ")), /*#__PURE__*/React.createElement(Text, {
      display: "block",
      color: "textSecondary",
      weight: "semiBold",
      s: {
        mt: 2
      }
    }, !!accountAnnualRevenue && /*#__PURE__*/React.createElement(Badge, {
      color: "infoGrey",
      display: "inline-block",
      s: {
        py: 0.5,
        mr: 2,
        mt: -0.5,
        mb: 2
      },
      "data-tooltip-id": "general-tooltip",
      "data-tooltip-html": "Annual Revenue",
      style: {
        cursor: "help",
        textDecoration: "underline dotted"
      }
    }, currency, " ", accountAnnualRevenue.toLocaleString("en-US")), !!accountIndustry && /*#__PURE__*/React.createElement(Badge, {
      color: "grey",
      display: "inline-block",
      s: {
        py: 0.5,
        mr: 2,
        mt: -0.5,
        mb: 2
      }
    }, accountIndustry), !!accountEmployees && /*#__PURE__*/React.createElement(Badge, {
      color: "grey",
      display: "inline-block",
      s: {
        py: 0.5,
        mr: 2,
        mt: -0.5,
        mb: 2
      }
    }, "Employees: ", accountEmployees.toLocaleString("en-US"))), /*#__PURE__*/React.createElement(Text, {
      weight: "semiBold",
      fontSize: 4.5,
      lineHeight: 6.5,
      display: "block",
      s: {
        my: 2
      }
    }, accountName)), !hideMessage && (accountDescription || !!customFields?.length) && /*#__PURE__*/React.createElement(Collapsable, {
      maxHeight: 0,
      type: CollapsableTypeEnum.BUTTON,
      s: {
        mb: 3
      },
      collapsedText: "View details",
      expandedText: "Hide details"
    }, !!customFields?.length && /*#__PURE__*/React.createElement(Card, {
      color: "transparent",
      border: true,
      fullWidth: true,
      s: {
        px: 2,
        py: 2,
        mt: 2,
        mb: 4
      }
    }, /*#__PURE__*/React.createElement(Table, {
      size: "s"
    }, /*#__PURE__*/React.createElement(Table.Body, null, customFields.map(field => {
      return field.value !== null && field.value !== undefined && /*#__PURE__*/React.createElement(Table.Tr, {
        key: field.name
      }, /*#__PURE__*/React.createElement(StyledTd, {
        noHover: true
      }, /*#__PURE__*/React.createElement(Text, {
        element: "span",
        color: "textSecondary",
        display: "inline-block"
      }, field.label, ":")), /*#__PURE__*/React.createElement(StyledTd, {
        noHover: true,
        width: "70%"
      }, field.type === "currency" ? /*#__PURE__*/React.createElement(Text, {
        element: "span",
        display: "block",
        weight: "semiBold",
        color: "text"
      }, `${currency} ${field.value.toLocaleString("en-US")}`) : field.type === "number" ? /*#__PURE__*/React.createElement(Text, {
        element: "span",
        display: "block",
        weight: "semiBold",
        color: "text"
      }, field.value.toLocaleString("en-US")) : field.type === "boolean" ? /*#__PURE__*/React.createElement(Text, {
        element: "span",
        display: "block",
        weight: "semiBold",
        color: "text"
      }, field.value ? "Yes" : "No") : field.type === "percent" ? /*#__PURE__*/React.createElement(Text, {
        element: "span",
        display: "block",
        weight: "semiBold",
        color: "text"
      }, `${field.value.toLocaleString("en-US")}%`) : field.value.toString().length > 50 ? /*#__PURE__*/React.createElement(Text, {
        element: "span",
        display: "block",
        weight: "semiBold",
        color: "text",
        style: {
          cursor: "help",
          textDecoration: "underline dotted"
        },
        "data-tooltip-id": "general-tooltip",
        "data-tooltip-html": `<div>${field.value.toString()}</div>`
      }, truncatedContent(field.value.toString(), 50)) : /*#__PURE__*/React.createElement(Text, {
        element: "span",
        display: "block",
        weight: "semiBold",
        color: "text"
      }, field.value.toString())));
    })))), /*#__PURE__*/React.createElement(Markdown, {
      text: accountDescription,
      fontSize: 4,
      lineHeight: 6,
      display: "block",
      s: {
        mt: 3
      }
    })));
  }
  if ([TopicFootprintTypeEnum.OPPORTUNITY].includes(type)) {
    const {
      opportunityUrl,
      opportunityName,
      userOwnedByName,
      userOwnedByUrl,
      opportunityAccountUrl,
      opportunityAccountName,
      opportunityStageName,
      opportunityProbability,
      opportunityDescription,
      opportunityCurrency,
      opportunityPreviousStageName,
      opportunityPreviousAmount,
      opportunityPreviousProbability,
      opportunityPreviousCloseDate,
      opportunityAmount,
      opportunityCloseDate
    } = data;
    const customFields = data.customFields ? data.customFields.filter((obj, index, self) => index === self.findIndex(o => o.name === obj.name)) : [];
    const currency = opportunityCurrency || "USD";
    const stageChanged = actions.includes(TopicFootprintActionEnum.CHANGED_STAGE);
    const amountChanged = actions.includes(TopicFootprintActionEnum.CHANGED_AMOUNT);
    const probabilityChanged = actions.includes(TopicFootprintActionEnum.CHANGED_PROBABILITY);
    const closeDateChanged = actions.includes(TopicFootprintActionEnum.CHANGED_CLOSE_DATE);
    return /*#__PURE__*/React.createElement(React.Fragment, null, !hideDetails && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      display: "block",
      color: "textSecondary",
      weight: "semiBold"
    }, /*#__PURE__*/React.createElement(FootprintActions, {
      actions: actions
    }), " a Salesforce", " ", /*#__PURE__*/React.createElement(Link, {
      href: opportunityUrl,
      underline: true
    }, "opportunity"), " ", userOwnedByName && /*#__PURE__*/React.createElement(Text, null, "owned by", " ", /*#__PURE__*/React.createElement(Link, {
      href: userOwnedByUrl,
      underline: true
    }, userOwnedByName), " ")), /*#__PURE__*/React.createElement(Text, {
      display: "block",
      color: "textSecondary",
      weight: "semiBold",
      s: {
        mt: 2
      }
    }, !!opportunityAccountUrl && !!opportunityAccountName && /*#__PURE__*/React.createElement(Link, {
      href: opportunityAccountUrl,
      s: {
        mr: 2,
        mb: 2
      },
      underline: true
    }, opportunityAccountName), !!opportunityAmount && /*#__PURE__*/React.createElement(Badge, {
      color: "infoGrey",
      display: "inline-block",
      s: {
        py: 0.5,
        mr: 2,
        mt: -0.5,
        mb: 2
      },
      "data-tooltip-id": "general-tooltip",
      "data-tooltip-html": "<div>Associated Revenue</div>",
      style: {
        cursor: "help",
        textDecoration: "underline dotted"
      }
    }, currency, " ", opportunityAmount.toLocaleString("en-US")), /*#__PURE__*/React.createElement(Badge, {
      color: "grey",
      display: "inline-block",
      s: {
        py: 0.5,
        mr: 2,
        mt: -0.5,
        mb: 2
      }
    }, opportunityStageName, !!opportunityProbability && ` | ${opportunityProbability.toFixed(0)}%`), !!opportunityCloseDate && /*#__PURE__*/React.createElement(Badge, {
      color: "grey",
      display: "inline-block",
      s: {
        py: 0.5,
        mt: -0.5,
        mb: 2
      }
    }, "Close date:", " ", new Date(opportunityCloseDate).toLocaleDateString("en-us", {
      year: "numeric",
      month: "short",
      day: "numeric"
    }))), /*#__PURE__*/React.createElement(Text, {
      weight: "semiBold",
      fontSize: 4.5,
      lineHeight: 6.5,
      display: "block",
      s: {
        my: 2
      }
    }, opportunityName)), !hideMessage && (opportunityDescription || stageChanged || amountChanged) && /*#__PURE__*/React.createElement(Collapsable, {
      maxHeight: 0,
      type: CollapsableTypeEnum.BUTTON,
      s: {
        mb: 3
      },
      collapsedText: "View details",
      expandedText: "Hide details"
    }, stageChanged && !!opportunityPreviousStageName && !!opportunityStageName && /*#__PURE__*/React.createElement(Text, {
      display: "block",
      color: "textSecondary",
      lineHeight: 6
    }, "- Stage changed from ", /*#__PURE__*/React.createElement(Underline, null, opportunityPreviousStageName), " to", " ", /*#__PURE__*/React.createElement(Underline, null, opportunityStageName)), amountChanged && !!opportunityPreviousAmount && !!opportunityAmount && /*#__PURE__*/React.createElement(Text, {
      display: "block",
      color: "textSecondary",
      lineHeight: 6
    }, "- Associated revenue changed from", " ", /*#__PURE__*/React.createElement(Underline, null, currency, " ", opportunityPreviousAmount.toLocaleString("en-US")), " ", "to", " ", /*#__PURE__*/React.createElement(Underline, null, currency, " ", opportunityAmount.toLocaleString("en-US"))), probabilityChanged && !!opportunityPreviousProbability && !!opportunityProbability && /*#__PURE__*/React.createElement(Text, {
      display: "block",
      color: "textSecondary",
      lineHeight: 6
    }, "- Probability changed from ", /*#__PURE__*/React.createElement(Underline, null, opportunityPreviousProbability, "%"), " to", " ", /*#__PURE__*/React.createElement(Underline, null, opportunityProbability, "%")), closeDateChanged && !!opportunityPreviousCloseDate && !!opportunityCloseDate && /*#__PURE__*/React.createElement(Text, {
      display: "block",
      color: "textSecondary",
      lineHeight: 6
    }, "- Close date changed from", " ", /*#__PURE__*/React.createElement(Underline, null, new Date(opportunityPreviousCloseDate).toLocaleDateString("en-us", {
      year: "numeric",
      month: "short",
      day: "numeric"
    })), " ", "to", " ", /*#__PURE__*/React.createElement(Underline, null, new Date(opportunityCloseDate).toLocaleDateString("en-us", {
      year: "numeric",
      month: "short",
      day: "numeric"
    }))), !!customFields?.length && /*#__PURE__*/React.createElement(Card, {
      color: "transparent",
      border: true,
      fullWidth: true,
      s: {
        px: 2,
        py: 2,
        mt: 2,
        mb: 4
      }
    }, /*#__PURE__*/React.createElement(Table, {
      size: "s"
    }, /*#__PURE__*/React.createElement(Table.Body, null, customFields.map(field => {
      return field.value !== null && field.value !== undefined && /*#__PURE__*/React.createElement(Table.Tr, {
        key: field.name
      }, /*#__PURE__*/React.createElement(StyledTd, {
        noHover: true
      }, /*#__PURE__*/React.createElement(Text, {
        element: "span",
        color: "textSecondary",
        display: "inline-block"
      }, field.label, ":")), /*#__PURE__*/React.createElement(StyledTd, {
        noHover: true,
        width: "70%"
      }, field.type === "currency" ? /*#__PURE__*/React.createElement(Text, {
        element: "span",
        display: "block",
        weight: "semiBold",
        color: "text"
      }, `${currency}${field.value.toLocaleString("en-US")}`) : field.type === "number" ? /*#__PURE__*/React.createElement(Text, {
        element: "span",
        display: "block",
        weight: "semiBold",
        color: "text"
      }, field.value.toLocaleString("en-US")) : field.type === "boolean" ? /*#__PURE__*/React.createElement(Text, {
        element: "span",
        display: "block",
        weight: "semiBold",
        color: "text"
      }, field.value ? "Yes" : "No") : field.type === "percent" ? /*#__PURE__*/React.createElement(Text, {
        element: "span",
        display: "block",
        weight: "semiBold",
        color: "text"
      }, `${field.value.toLocaleString("en-US")}%`) : field.value.toString().length > 50 ? /*#__PURE__*/React.createElement(Text, {
        element: "span",
        display: "block",
        weight: "semiBold",
        color: "text",
        style: {
          cursor: "help",
          textDecoration: "underline dotted"
        },
        "data-tooltip-id": "general-tooltip",
        "data-tooltip-html": `<div>${field.value.toString()}</div>`
      }, truncatedContent(field.value.toString(), 50)) : /*#__PURE__*/React.createElement(Text, {
        element: "span",
        display: "block",
        weight: "semiBold",
        color: "text"
      }, field.value.toString())));
    })))), /*#__PURE__*/React.createElement(Markdown, {
      text: opportunityDescription,
      fontSize: 4,
      lineHeight: 6,
      display: "block",
      s: {
        mt: 3
      }
    })));
  }
  if ([TopicFootprintTypeEnum.EMAIL].includes(type)) {
    const {
      emailMessageUrl,
      emailMessageSubject,
      emailMessageContent,
      emailMessageContentStructured,
      emailMessageFrom,
      emailMessageTo,
      emailMessageIncoming,
      opportunityName
    } = data;
    const limitedStructuredContent = truncatedContent(emailMessageContentStructured.currentMessage, 130);
    return /*#__PURE__*/React.createElement(React.Fragment, null, !hideDetails && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      display: "block",
      color: "textSecondary",
      weight: "semiBold",
      lineHeight: 6
    }, /*#__PURE__*/React.createElement(FootprintActions, {
      actions: actions
    }), " ", /*#__PURE__*/React.createElement(Link, {
      href: emailMessageUrl,
      underline: true
    }, "email"), " ", emailMessageIncoming ? /*#__PURE__*/React.createElement(Text, null, "from ", emailMessageFrom) : /*#__PURE__*/React.createElement(Text, null, "to ", emailMessageTo), !!emailMessageSubject.length && /*#__PURE__*/React.createElement(Badge, {
      color: "grey",
      display: "inline",
      s: {
        py: 0.5,
        mx: 2,
        mt: -0.5
      }
    }, emailMessageSubject)), /*#__PURE__*/React.createElement(Text, {
      weight: "semiBold",
      fontSize: 4.5,
      lineHeight: 6.5,
      display: "block",
      s: {
        my: 1
      }
    }, opportunityName), /*#__PURE__*/React.createElement(Text, {
      fontSize: 3,
      lineHeight: 4.5,
      weight: "bold",
      display: "block",
      s: {
        mt: 2
      }
    }, emailMessageFrom, " wrote:"), /*#__PURE__*/React.createElement(Text, {
      fontSize: 4,
      lineHeight: 6,
      s: {
        mt: 3
      }
    }, "\"", limitedStructuredContent, "\"")), !hideMessage && emailMessageContent && /*#__PURE__*/React.createElement(Collapsable, {
      maxHeight: 0,
      type: CollapsableTypeEnum.BUTTON,
      s: {
        my: 3
      },
      collapsedText: "View full conversation",
      expandedText: "Hide full conversation"
    }, /*#__PURE__*/React.createElement(Markdown, {
      text: emailMessageContent,
      fontSize: 3.5,
      lineHeight: 4.5,
      display: "block"
    })));
  }
  return /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    weight: "semiBold"
  }, "Unknown event");
};
export default TopicFootprintContentSalesforce;